<template>
	<div>
		<el-dialog
			:title="lang.addCoTeacher"
			:visible.sync="show"
			:append-to-body="true"
			width="25%"
			height="80%"
			:before-close="handleClose"
			class="addNewPP customWidth"
		>
			<div style="display: flex; justify-content: space-between">
				<div
					style="
						width: 100px;
						overflow: auto;
						overflow-x: hidden;
						height: 350px;
						flex-shrink: 0;
						padding-right: 10px;
					"
				>
					<div
						class="CollaborativeCss"
						:class="{ CollaborativeCss2: collid == '' }"
						@click="getTeacher('')"
					>
						{{ lang.all }}
					</div>
					<div
						class="CollaborativeCss"
						:class="{ CollaborativeCss2: i.id == collid }"
						@click="getTeacher(i.id)"
						v-for="i in CollaborativeTeaList"
						:key="i.id"
					>
						<el-tooltip placement="top" :content="i.name">
							<span>{{ i.name }}</span>
						</el-tooltip>
					</div>
					<div
						class="CollaborativeCss"
						:class="{ CollaborativeCss2: collid == '1xpz' }"
						@click="getTeacherCopy()"
					>
						{{ lang.other }}
					</div>
				</div>
				<div style="width: calc(100% - 100px)" v-loading="CollLoading">
					<div class="people">
						<div class="people_top">
							<div class="people_top_right">
								<div class="people_search">
									<el-input
										:placeholder="lang.ssSearchMemberName"
										v-model="searchTN"
										@keyup.enter.native="getTeacher(collid)"
									></el-input>
									<div class="search_img" @click="getTeacher(collid)">
										<img src="@/assets/img/teachingMode/search.png" alt />
									</div>
								</div>
							</div>
							<div
								class="people_nav"
								style="display: flex; align-items: center"
							>
								<div class="check_class_left_title">{{ lang.ssSelectMember }}</div>
								<div
									style="display: flex; align-items: center; margin-left: auto"
								>
									<el-checkbox
										v-model="checkAll2"
										@change="handleCheckAllChange2"
										class="all_check"
										>{{ lang.selectAll }}</el-checkbox
									>
								</div>
							</div>
						</div>
						<el-checkbox-group
							v-model="checkList"
							class="people_name"
							v-if="teacherJuri.length"
							@change="InviteChange2"
						>
							<el-checkbox
								v-for="item in teacherJuri"
								:key="item.userid"
								:label="item.userid"
							>
								<div class="t_j_box">
									<el-tooltip
										placement="top"
										:content="item.name ? item.name : lang.ssNoName"
									>
										<span>{{ item.name ? item.name : lang.ssNoName }}</span>
									</el-tooltip>
									<el-tooltip
										placement="top"
										:content="item.username?item.username.split('@')[0]:''"
									>
										<span>{{ item.username?item.username.split("@")[0]:'' }}</span>
									</el-tooltip>
									<el-tooltip placement="top" :content="item.school">
										<span>{{ item.school }}</span>
									</el-tooltip>
								</div>
							</el-checkbox>
						</el-checkbox-group>
						<div style="text-align: center; margin-top: 10px" v-else>
							{{ lang.noData }}
						</div>
					</div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="close()">{{ lang.cancel }}</el-button>
				<el-button type="primary" @click="submit()">{{ lang.queding }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			teacherJuri: [],
			checkList: [],
			collid: "",
			CollaborativeCss: [],
			CollaborativeTeaList:[],
			CollLoading: false,
			searchTN: "",
			checkAll2:false,
		};
	},
	methods: {
		open(data) {
			if(data.length>0)this.checkList = JSON.parse(JSON.stringify(data));
			this.getTeacher('')
			this.show = true;
		},
		close() {
			this.show = false;
		},
		submit() {
			this.$emit("success",this.checkList)
		},
		getTeacher(val) {
			this.CollLoading = true;
			this.collid = "";
			this.collid = !val ? "" : val;

			let params = {
				oid:
					this.$store.state.user.org && this.$store.state.user.org != "undefined" && this.$store.state.user.org != "null"
						? this.$store.state.user.org
						: this.$store.state.user.organizeid,
				cu: "",
				cn: this.searchTN,
				coll: this.collid,
			};
			this.ajax
				.get(
					this.$store.state.api +
						(this.user.org && this.user.org != "undefined" && this.user.org != "null"
							? "selectCollaborativeMembersOrg"
							: "selectCollaborativeMembers"),
					params
				)
				.then((res) => {
					let teacherJuri = res.data[0];
					this.CollaborativeTeaList = res.data[1];

					for (var i = 0; i < teacherJuri.length; i++) {
						if (teacherJuri[i].userid == this.userid) {
							teacherJuri.splice(i, 1);
							break;
						}
					}
					this.teacherJuri = teacherJuri;

					let _check = [];
					let _check2 = [];
					for (var i3 = 0; i3 < this.teacherJuri.length; i3++) {
						var gid = this.teacherJuri[i3].userid;
						_check.push(gid);
					}
					for (var i2 = 0; i2 < this.checkList.length; i2++) {
						var _id = this.checkList[i2];
						if (_check.indexOf(_id) !== -1) {
							_check2.push(_id);
						}
					}

					if (!(_check2.length == 0 && _check.length == 0)) {
						this.checkAll2 = _check2.length === _check.length;
					}
					this.CollLoading = false;
				})
				.catch((err) => {
					console.error(err);
					this.CollLoading = false;
				});
		},
		handleCheckAllChange2(val) {
			if (val) {
        for (var i = 0; i < this.teacherJuri.length; i++) {
          var gid = this.teacherJuri[i].userid;
          if (this.checkList.indexOf(gid) === -1) {
            this.checkList.push(gid);
          }
        }
      } else {
        let _check = [];
        let _check2 = [];
        for (var i2 = 0; i2 < this.teacherJuri.length; i2++) {
          var gid2 = this.teacherJuri[i2].userid;
          _check.push(gid2);
        }
        for (var i3 = 0; i3 < this.checkList.length; i3++) {
          var _id = this.checkList[i3];
          if (_check.indexOf(_id) === -1) {
            _check2.push(_id);
          }
        }
        this.checkList = _check2;
      }
		},
		getTeacherCopy(){
      this.CollLoading=true

      this.collid = ''
      this.collid = '1xpz'
      let params = {
        oid:
				this.$store.state.user.org && this.$store.state.user.org != "undefined" && this.$store.state.user.org != "null"
            ? this.$store.state.user.org
            : this.$store.state.user.organizeid,
        cu: "",
        cn: this.searchTN,
        coll: ''
      };
      this.ajax
        .get(
          this.$store.state.api +
            (this.$store.state.user.org && this.$store.state.user.org != "undefined" && this.$store.state.user.org != "null"
              ? "selectCollaborativeMembersOrg"
              : "selectCollaborativeMembers"),
          params
        )
        .then((res) => {
          let teacherJuri = res.data[0];
          this.CollaborativeTeaList = res.data[1];
          for (var i = 0; i < teacherJuri.length; i++) {
            if (teacherJuri[i].userid == this.userid) {
              teacherJuri.splice(i, 1);
              break;
            }
          }

          this.teacherJuri = teacherJuri.filter((i)=>{
            return (i.cclassid == '' || i.cclassid == null)
          })
          console.log(' this.teacherJuri', this.teacherJuri);


          let _check = [];
          let _check2 = [];
          for (var i3 = 0; i3 < this.teacherJuri.length; i3++) {
            var gid = this.teacherJuri[i3].userid;
            _check.push(gid);
          }
          for (var i2 = 0; i2 < this.checkboxList3.length; i2++) {
            var _id = this.checkboxList3[i2];
            if (_check.indexOf(_id) !== -1) {
              _check2.push(_id);
            }
          }
          
          if (!(_check2.length==0 && _check.length==0)) {
						this.checkAll2 = _check2.length === _check.length;
          }
          this.CollLoading=false

        })
        .catch((err) => {
          console.error(err);
          this.CollLoading=false
        });
    },
		InviteChange2(){

		},
		handleClose(done) {
			done()
		},
	},
	mounted(){
		this.getTeacher('')
	},
};
</script>

<style scoped>
.addNewPP>>>.el-dialog__body {
  padding: 5px 20px;
}

.addNewPP>>>.el-dialog {
  margin-top: 5vh !important;
}

.addNewPP2>>>.el-dialog__body {
  padding: 5px 0;
}

.addNewPP2>>>.el-dialog {
  margin-top: 5vh !important;
}

.customWidth>>>.el-dialog {
  min-width: 600px !important;
}

.CollaborativeCss {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 0;
  cursor: pointer;
}

.CollaborativeCss >>> .el-tooltip {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.CollaborativeCss2 {
  background: #e0eafb;
  color: #3681fc;
  font-weight: 700;
  border-radius: 5px;
}

.people {
  border: 1px solid rgb(229 229 229);
  /* height: 495px; */
  height: 350px;
  border-radius: 5px;
  width: 100%;
  overflow: auto;
}

.people_top {
  display: flex;
  width: 100%;
  /* justify-content: space-between; */
  /* align-items: center; */
  flex-direction: column;
  padding: 10px 10px 0;
  box-sizing: border-box;
}

.people_nav,
.people_top_right {
  /* padding: 20px 0 0 20px; */
}

.people_top_right {
  height: 40px;
  margin-bottom: 10px;
}

.people_search {
  display: flex;
  position: relative;
}

.people_search>>>.el-input__inner {
  /* height: 25px; */
  width: 100%;
}

.search_img {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.search_img>img {
  width: 100%;
  height: 100%;
}

.check_class_left_title {
  font-size: 16px;
  font-weight: 700;
}

.all_check {
  display: flex;
  align-items: center;
  padding: 2px 0 0;
  margin-left: 10px;
}

.all_check>>>.el-checkbox__label {
  line-height: 18px;
}


.people_name {
  display: flex;
  justify-content: flex-start;
  padding: 20px 10px;
  flex-direction: column;
  flex-wrap: wrap;
}

.p_box {
  position: relative;
}

.people_name>>>.el-checkbox {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.people_name>>>.el-checkbox .el-checkbox__label {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}

.t_j_box {
  display: flex;
}

.t_j_box span:nth-child(1) {
  width: 15%;
  overflow: hidden;
  margin-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.t_j_box span:nth-child(2) {
  width: 30%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.t_j_box span:nth-child(3) {
  max-width: calc(55% - 20px);
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
